import { useState } from 'react';

import { doRequest } from '@r1-frontend/do-request';
import { check, ICheckResponse } from '@r1-frontend/api-domru/api-loyalty/v1/unauth-promocode/check';

import FullBuyAnalytics from '~/src/features/full-buy/analytics';
import { IPromoCode } from '~/src/features/full-buy/store/initialState';

interface ICheckPromoCode {
    processCheck: (promoCode: string) => void,
    isError: boolean,
    errorMessage: string,
    isLoading: boolean,
    clearErrors: () => void,
}

const useCheckPromoCode = (providerId: number, domain: string, analytics: FullBuyAnalytics, callback: (data: IPromoCode) => void) : ICheckPromoCode => {
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const processCheck = async(promoCode: string) => {
        analytics.summary.promocodeClickVerification();
        setIsLoading(true);

        const respPromoCode = await doRequest.apiLoyalty<ICheckResponse>(
            check(providerId, promoCode),
        );

        if (respPromoCode.isSuccess) {
            const data: IPromoCode = {
                value: promoCode,
                amount: respPromoCode.payload.sum,
                type: respPromoCode.payload.type,
            };
            callback(data);
        } else {
            analytics.summary.promocodeFailVerification(promoCode);
            setIsError(true);
            setErrorMessage(respPromoCode.error.message);
        }

        setIsLoading(false);
    };

    const clearErrors = () => {
        setIsError(false);
        setErrorMessage('');
    };

    return { processCheck, isError, errorMessage, isLoading, clearErrors };
};

export default useCheckPromoCode;
